import naturalCompare from './naturalCompare';
/**
 * Shared by CartothequePage (entries, by `no`), ExhibitionPage (findings, by
 * `label`), and CardLayoutEditor (entries, by `no`) - natural-sort the
 * number/label field first ("2" before "10"), falling back to the species
 * name when two rows compare equal there (e.g. a société that doesn't
 * number its cards at all, every entry's own `no` comparing equal
 * otherwise).
 */
export default function compareByNoThenSpeciesName(noAccessor) {
  return (a, b) => {
    const byNo = naturalCompare(noAccessor(a), noAccessor(b));
    if (byNo !== 0) return byNo;
    const nameA = a.speciesDisplay() && a.speciesDisplay()?.canonicalName || '';
    const nameB = b.speciesDisplay() && b.speciesDisplay()?.canonicalName || '';
    return nameA.localeCompare(nameB);
  };
}
flarum.reg.add('champis-exhibitions', 'forum/utils/compareByNoThenSpeciesName', compareByNoThenSpeciesName);